import { Component, ComponentInterface, Host, Prop, State, Watch, h } from '@stencil/core';
import { getProjectIcon } from '../../services/db/filesystem.service';

@Component({
  tag: 'coreo-app-icon',
  styleUrl: 'app-icon.scss',
  scoped: true
})
export class CoreoAppIconComponent implements ComponentInterface {

  @Prop() appId!: number;
  @Prop() iconSrc: string; // for uninstalled apps, where icon is not saved locally
  @State() src: string;

  @Watch('appId') handleAppIdChange() {
    this.loadIcon();
  }

  private fallbackIcon = '/assets/icon/no-icon.png';

  private async loadIcon() {
    this.src = this.iconSrc ?? (await getProjectIcon(this.appId)) ?? this.fallbackIcon;
  }

  async componentWillLoad() {
    this.loadIcon();
  }

  render() {
    return <Host>
      <img alt="" src={this.src} />
    </Host>
  }
}
